// extracted by mini-css-extract-plugin
export default {"list":"Stepper_list__4v-a+","item":"Stepper_item__tq8nR","dot":"Stepper_dot__bB4HC","label":"Stepper_label__7E8TF","done":"Stepper_done__M8wLe","current":"Stepper_current__e0KVY"};